//  store.js 中都mutation中增加添加和删除token的方法
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        baseURL: ''
    },
    mutations: {}
})


// WEBPACK FOOTER //
// ./src/store/store.js